<div class="search-modal" (keydown)="onKeyDown($event)">
  <div class="search-modal-backdrop" (click)="onCloseClick()"></div>
  <div class="search-modal-content" (click)="stopPropagation($event)">
    <div class="search-input-container">
      <i class="fas fa-search search-icon"></i>
      <input 
        type="text" 
        class="search-input" 
        [placeholder]="'SEARCH.PLACEHOLDER' | translate"
        [(ngModel)]="searchQuery" 
        (input)="onSearchInput($event)"
        autofocus
      >
    </div>
    
    <!-- Results dropdown - only shows when there are results -->
    <div class="search-results-container" *ngIf="searchQuery && (isSearching || searchResults.length > 0 || (searchQuery && !isSearching))">
      <div *ngIf="isSearching" class="search-loading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      
      <div *ngIf="!isSearching && searchResults.length === 0 && searchQuery" class="search-no-results">
        <p>{{ 'SEARCH.NO_RESULTS' | translate }}</p>
      </div>
      
      <div *ngFor="let result of searchResults" class="search-result-item" (click)="navigateToResult(result)">
        <h5>{{ result.pageTitleKey }}</h5>
        <h6>{{ result.matchingSectionTitleKey }}</h6>
        <p [innerHTML]="result.excerpt"></p>
      </div>
    </div>
  </div>
</div>